// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "site" + "-" + "e36e8f7aaa5a5df7e783" + ".css";
};